var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_gallery-favorite",
    "data-name": "vuesax/bulk/gallery-favorite",
    transform: "translate(-428 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery-favorite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.44,1.9v2.29c0,3.64-2.17,5.81-5.81,5.81H5.25C2.7,10,.86,8.933,0,7.033l.11-.08,4.92-3.3a2.221,2.221,0,0,1,2.64.14l.34.28a2.229,2.229,0,0,0,2.82,0L14.99.5a2.229,2.229,0,0,1,2.82,0Z",
    transform: "translate(430.56 263.997)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M18.97,6H16.03A1.866,1.866,0,0,1,14,3.97V1.03A2.336,2.336,0,0,1,14.22,0H5.81C2.17,0,0,2.17,0,5.81v8.38a6.723,6.723,0,0,0,.56,2.84l.11-.08,4.92-3.3a2.221,2.221,0,0,1,2.64.14l.34.28a2.229,2.229,0,0,0,2.82,0l4.16-3.57a2.229,2.229,0,0,1,2.82,0L20,11.9V5.78A2.336,2.336,0,0,1,18.97,6Z",
    transform: "translate(430 254)",
    fill: "#908fa2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.76,2.38A2.38,2.38,0,1,1,2.38,0,2.38,2.38,0,0,1,4.76,2.38Z",
    transform: "translate(434.62 257.62)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(428 252)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M6,7H1A1,1,0,0,1,0,6V1A1,1,0,0,1,1,0H6A1,1,0,0,1,7,1V6A1,1,0,0,1,6,7ZM3.5,4.889a.4.4,0,0,1,.328.226l.022.036a.347.347,0,0,0,.291.159.338.338,0,0,0,.166-.044l.345-.19a.366.366,0,0,0,.178-.22.352.352,0,0,0-.038-.276.372.372,0,0,1-.04-.386.405.405,0,0,1,.368-.16.372.372,0,0,0,.38-.364V3.331a.373.373,0,0,0-.38-.365.4.4,0,0,1-.368-.16.37.37,0,0,1,.04-.385.354.354,0,0,0,.038-.277.367.367,0,0,0-.178-.22l-.345-.19a.328.328,0,0,0-.165-.044.343.343,0,0,0-.292.159l-.022.036a.4.4,0,0,1-.328.226.4.4,0,0,1-.329-.226L3.149,1.85a.341.341,0,0,0-.29-.159.334.334,0,0,0-.166.044l-.345.19a.358.358,0,0,0-.177.22.348.348,0,0,0,.037.277.369.369,0,0,1,.04.385.4.4,0,0,1-.367.16.372.372,0,0,0-.379.365v.338a.372.372,0,0,0,.379.364.4.4,0,0,1,.367.16.37.37,0,0,1-.04.386.344.344,0,0,0-.037.275.361.361,0,0,0,.177.221l.345.19a.34.34,0,0,0,.455-.115l.023-.036A.4.4,0,0,1,3.5,4.889Zm0-.766A.623.623,0,1,1,4.148,3.5.638.638,0,0,1,3.5,4.123Z",
    transform: "translate(444 253)",
    fill: "#908fa2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.b947d79fc739f4664b49a1867069ede8.svg";
export { ForwardRef as ReactComponent };